export default __webpack_public_path__ + "static/media/front_tree.00ed7284.svg";